import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { NO_IMAGE_URL } from 'config/constants';

import './ItemImage.scss';

@observer
export default class ItemImage extends Component {
	static propTypes = {
		imageUrl: PropTypes.string.isRequired,
		name: PropTypes.string.isRequired,
		itemNumber: PropTypes.string,
	};

	static defaultProps = {
		itemNumber: '',
	};

	imageUrl = this.props.imageUrl;
	name = this.props.name;
	itemNumber = this.props.itemNumber;

	@observable showModal = false;

	hasImage(url) {
		const NO_IMAGE = 'no_image_large';
		if (url) {
			return !url.includes(NO_IMAGE);
		}

		return false;
	}

	render() {
		const imageUrl = this.hasImage(this.imageUrl)
			? this.imageUrl
			: NO_IMAGE_URL;
		return (
			<div className="col-md-2 col-sm-2 col-xs-2 ItemImage">
				<img src={imageUrl} alt={this.name} id="ItemImage" />
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/ItemImage/index.js